/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CancelAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function CancelAction({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/CancelAction",
  isSubmitting
  
}) {
let scheduleNoteIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'schedule_note',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isSubmitting
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 text="Cancel"
 data="schedule_note"
 disabled={scheduleNoteIsSubmittingData}
 onClick={onClick}
/>
{children}
</React.Fragment>)
}